(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["f7-entrega-internacional"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function abrir(caixa) {
    caixa.hidden = false;
    if (reduzido) { caixa.style.height = 'auto'; return; }
    // Mede a altura real e anima até lá. Um max-height fixo cortaria a
    // Europa, que tem 29 países.
    var alvo = caixa.scrollHeight;
    caixa.style.height = '0px';
    caixa.style.transition = 'height 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
    requestAnimationFrame(function () {
      caixa.style.height = alvo + 'px';
    });
    caixa.addEventListener('transitionend', function fim(e) {
      if (e.propertyName !== 'height') return;
      caixa.style.height = 'auto';        // solta, para aguentar rotação do ecrã
      caixa.removeEventListener('transitionend', fim);
    });
  }

  function fechar(caixa) {
    if (reduzido) { caixa.hidden = true; return; }
    caixa.style.height = caixa.scrollHeight + 'px';
    requestAnimationFrame(function () {
      caixa.style.transition = 'height 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
      caixa.style.height = '0px';
    });
    caixa.addEventListener('transitionend', function fim(e) {
      if (e.propertyName !== 'height') return;
      caixa.hidden = true;
      caixa.removeEventListener('transitionend', fim);
    });
  }

  function iniciar(raiz) {
    if (raiz.dataset.f7Pronto === '1') return;
    raiz.dataset.f7Pronto = '1';

    var regioes = [].slice.call(raiz.querySelectorAll('[data-f7-regiao]'));

    regioes.forEach(function (reg) {
      var caixa = reg.querySelector('[data-f7-escondidos]');
      var botoes = [].slice.call(reg.querySelectorAll('[data-f7-toggle]'));
      if (!caixa || !botoes.length) return;

      botoes.forEach(function (b) {
        b.addEventListener('click', function () {
          var aberto = b.getAttribute('aria-expanded') === 'true';

          // Um de cada vez, como no original.
          if (!aberto) {
            regioes.forEach(function (outra) {
              if (outra === reg) return;
              var c2 = outra.querySelector('[data-f7-escondidos]');
              if (c2 && !c2.hidden) fechar(c2);
              outra.classList.remove('is-open');
              outra.querySelectorAll('[data-f7-toggle]').forEach(function (b2) {
                b2.setAttribute('aria-expanded', 'false');
                var t2 = b2.querySelector('[data-f7-texto]');
                if (t2 && b2.dataset.fechado) t2.textContent = b2.dataset.fechado;
              });
            });
          }

          if (aberto) { fechar(caixa); } else { abrir(caixa); }
          reg.classList.toggle('is-open', !aberto);

          botoes.forEach(function (b2) {
            b2.setAttribute('aria-expanded', String(!aberto));
            var t2 = b2.querySelector('[data-f7-texto]');
            if (!t2) return;
            t2.textContent = !aberto
              ? (b2.dataset.aberto || t2.textContent)
              : (b2.dataset.fechado || t2.textContent);
          });
        });
      });
    });
  }

  function arranca() {
    document.querySelectorAll('[data-f7-ei]').forEach(function (raiz) {
      // Guarda os dois textos em cada botão, lidos do schema pela ordem
      // em que o Liquid os escreveu.
      raiz.querySelectorAll('[data-f7-toggle]').forEach(function (b) {
        var t = b.querySelector('[data-f7-texto]');
        if (t && !b.dataset.fechado) {
          b.dataset.fechado = t.textContent.trim();
          b.dataset.aberto = b.classList.contains('f7-ei__botao--mob')
            ? (raiz.dataset.menos || 'Menos')
            : (raiz.dataset.verMenos || 'Ver menos');
        }
      });
      iniciar(raiz);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else { arranca(); }
  document.addEventListener('shopify:section:load', arranca);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f7-entregas"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  function liga(raiz) {
    if (raiz.dataset.f7Pronto === '1') return;
    raiz.dataset.f7Pronto = '1';
    if (raiz.getAttribute('data-pausa') !== '1') return;
    var fita = raiz.querySelector('.f7-ent__fita');
    if (!fita) return;
    raiz.addEventListener('mouseenter', function () { fita.style.animationPlayState = 'paused'; });
    raiz.addEventListener('mouseleave', function () { fita.style.animationPlayState = 'running'; });
  }
  function arranca() { document.querySelectorAll('.f7-ent').forEach(liga); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else { arranca(); }
  document.addEventListener('shopify:section:load', arranca);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f7-galerica-circular"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var reduzido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function iniciar(raiz) {
    if (raiz.dataset.f7Pronto === '1') return;
    raiz.dataset.f7Pronto = '1';

    var anel = raiz.querySelector('[data-f7-anel]');
    var cartas = [].slice.call(raiz.querySelectorAll('[data-f7-carta]'));
    if (!anel || !cartas.length) return;

    var n = cartas.length;
    var passo = 360 / n;
    var modo = raiz.getAttribute('data-modo');
    var voltas = parseFloat(raiz.getAttribute('data-voltas')) || 1;
    var vel = (parseFloat(raiz.getAttribute('data-velocidade')) || 0) / 100;
    var opMin = (parseFloat(raiz.getAttribute('data-opacidade-min')) || 30) / 100;

    cartas.forEach(function (c, i) { c.style.setProperty('--a', (i * passo) + 'deg'); });

    var rot = 0, aScrollar = false, relogio = null, visivel = false;

    function progresso() {
      var r = raiz.getBoundingClientRect();
      var percorrivel = r.height - window.innerHeight;
      if (percorrivel <= 0) return 0;
      return Math.min(1, Math.max(0, (0 - r.top) / percorrivel));
    }

    function pintar() {
      anel.style.transform = 'rotateY(' + rot + 'deg)';
      for (var i = 0; i < n; i++) {
        var rel = ((i * passo) + rot) % 360;
        if (rel < 0) rel += 360;
        var dist = rel > 180 ? 360 - rel : rel;
        cartas[i].style.opacity = Math.max(opMin, 1 - (dist / 180));
      }
    }

    function aoScroll() {
      if (modo !== 'scroll') return;
      aScrollar = true;
      rot = progresso() * 360 * voltas;
      pintar();
      clearTimeout(relogio);
      relogio = setTimeout(function () { aScrollar = false; }, 150);
    }

    if (modo === 'scroll') {
      window.addEventListener('scroll', aoScroll, { passive: true });
      window.addEventListener('resize', aoScroll, { passive: true });
      aoScroll();
    }

    function laco() {
      if (visivel && !aScrollar && vel > 0 && !reduzido) { rot += vel; pintar(); }
      requestAnimationFrame(laco);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { e.forEach(function (x) { visivel = x.isIntersecting; }); },
        { threshold: 0 }).observe(raiz);
    } else { visivel = true; }

    pintar();
    requestAnimationFrame(laco);
  }

  function arranca() { document.querySelectorAll('[data-f7-gal]').forEach(iniciar); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else { arranca(); }
  document.addEventListener('shopify:section:load', arranca);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["f7-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Só um card no site inteiro pode ter som. Guardado fora do laço para
  // funcionar mesmo com duas secções de reels na mesma página.
  var comSom = null;

  function silenciar(wrap) {
    var v = wrap.querySelector('[data-tnf-video]');
    var b = wrap.querySelector('[data-tnf-sound]');
    if (v) v.muted = true;
    if (b) b.setAttribute('aria-pressed', 'false');
    wrap.classList.remove('has-sound');
  }

  function silenciarTodos(excepto) {
    document.querySelectorAll('[data-tnf-wrap]').forEach(function (w) {
      if (w !== excepto) silenciar(w);
    });
  }

  var carrosseis = [];

  document.querySelectorAll('[data-tnf-carousel]').forEach(function (carousel) {
    var raiz  = carousel.closest('[data-tnf-reels]') || carousel;
    var track = carousel.querySelector('[data-tnf-track]');
    var prev  = carousel.querySelector('[data-tnf-prev]');
    var next  = carousel.querySelector('[data-tnf-next]');
    if (!track) return;

    var pausarFora  = raiz.getAttribute('data-pause-offscreen') !== 'false';
    var accaoToque  = raiz.getAttribute('data-tap') === 'playpause' ? 'playpause' : 'sound';
    var wraps       = Array.prototype.slice.call(track.querySelectorAll('[data-tnf-wrap]'));
    var noEcra      = false;
    var retentativa = null;

    var videoRadius = getComputedStyle(raiz).getPropertyValue('--tr-video-radius');
    if (videoRadius && parseInt(videoRadius) > 0) {
      wraps.forEach(function (w) { w.style.margin = '4px 4px 0'; });
    }

    // ── setas ──────────────────────────────────────────────────────────────
    function passo() {
      var s = track.querySelector('.tnf-reels__slide');
      return s ? s.offsetWidth + (parseInt(getComputedStyle(track).gap) || 16) : 300;
    }
    function actualizarSetas() {
      if (!prev || !next) return;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -passo(), behavior: prefersReduced ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: passo(), behavior: prefersReduced ? 'auto' : 'smooth' }); });
    track.addEventListener('scroll', actualizarSetas, { passive: true });
    actualizarSetas();

    // ── vídeo ──────────────────────────────────────────────────────────────
    function carregar(v) {
      if (v && v.dataset.src && !v.src) {
        v.src = v.dataset.src;
        v.removeAttribute('data-src');
      }
    }

    function tocar(wrap) {
      var v = wrap.querySelector('[data-tnf-video]');
      if (!v) return;
      carregar(v);
      // O card escolhido pelo cliente mantém o som; todos os outros arrancam
      // em mudo, senão o browser recusa o autoplay.
      if (wrap !== comSom) v.muted = true;
      if (!v.paused) { wrap.classList.add('is-playing'); return; }
      var p = v.play();
      if (p && p.then) {
        p.then(function () { wrap.classList.add('is-playing'); })
         .catch(function () { wrap.classList.remove('is-playing'); });
      }
    }

    function parar(wrap) {
      var v = wrap.querySelector('[data-tnf-video]');
      if (!v) return;
      v.pause();
      wrap.classList.remove('is-playing');
    }

    // Todos ao mesmo tempo. A segunda passagem apanha os que o telemóvel
    // recusou por falta de descodificadores de hardware.
    function tocarTodos() {
      wraps.forEach(tocar);
      clearTimeout(retentativa);
      retentativa = setTimeout(function () {
        if (!noEcra) return;
        wraps.forEach(function (w) {
          var v = w.querySelector('[data-tnf-video]');
          if (v && v.paused) tocar(w);
        });
      }, 1200);
    }

    function pararTodos() {
      clearTimeout(retentativa);
      wraps.forEach(parar);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          noEcra = e.isIntersecting;
          if (noEcra) {
            tocarTodos();
          } else if (pausarFora) {
            pararTodos();
            // Só mexe no som se o card escolhido for desta secção.
            if (comSom && wraps.indexOf(comSom) > -1) { silenciar(comSom); comSom = null; }
          }
        });
      }, { threshold: 0.01, rootMargin: '200px 0px' }).observe(carousel);
    } else {
      noEcra = true;
      tocarTodos();
    }

    // ── som ────────────────────────────────────────────────────────────────
    function alternarSom(wrap) {
      var v = wrap.querySelector('[data-tnf-video]');
      var b = wrap.querySelector('[data-tnf-sound]');
      if (!v) return;
      if (v.muted) {
        silenciarTodos(wrap);
        comSom = wrap;
        carregar(v);
        v.muted = false;
        if (b) b.setAttribute('aria-pressed', 'true');
        wrap.classList.add('has-sound');
        tocar(wrap);
      } else {
        silenciar(wrap);
        if (comSom === wrap) comSom = null;
      }
    }

    wraps.forEach(function (wrap) {
      var botao = wrap.querySelector('[data-tnf-sound]');
      if (botao) {
        botao.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          alternarSom(wrap);
        });
      }

      // Toque no vídeo: por defeito escolhe o áudio, que é o gesto natural.
      wrap.addEventListener('click', function (ev) {
        if (ev.target.closest('.tnf-reels__overlay') || ev.target.closest('[data-tnf-sound]')) return;
        if (accaoToque === 'sound') { alternarSom(wrap); return; }
        var v = wrap.querySelector('[data-tnf-video]');
        if (!v) return;
        if (v.paused) tocar(wrap); else parar(wrap);
      });
    });

    // Autoplay bloqueado (Modo de Poupança do iOS): o primeiro toque recupera.
    document.addEventListener('pointerdown', function () {
      if (noEcra) tocarTodos();
    }, { once: true, passive: true });

    carrosseis.push({
      pausar:  pararTodos,
      retomar: function () { if (noEcra) tocarTodos(); }
    });
  });

  // Separador escondido: pausa tudo e devolve a bateria. Registado uma vez.
  document.addEventListener('visibilitychange', function () {
    carrosseis.forEach(function (c) {
      if (document.hidden) c.pausar(); else c.retomar();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-new"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
/*
    if (!document.querySelector('#swiper-stylesheet')) {
      const stylesheet = document.createElement('link')
      stylesheet.setAttribute('href', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.css')
      stylesheet.setAttribute('rel', 'stylesheet')
      stylesheet.setAttribute('id', 'swiper-stylesheet')
      stylesheet.setAttribute('integrity', 'sha256-5nkrwjVsiNfKz3NR1k2h5+qt5pS5SF2u9/TIT1hElow=')
      stylesheet.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(stylesheet)
    }

    if (!document.querySelector('#swiper-script')) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11.1.4/swiper-bundle.min.js')
      script.setAttribute('id', 'swiper-script')
      script.setAttribute('integrity', 'sha256-rCACDWCp/VzIh0rsB+ipQCM9XBvO8HNe0fNSOa4sys0=')
      script.setAttribute('crossorigin', 'anonymous')
      document.head.appendChild(script)
    }
*/
    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)
    
    this.querySelectorAll('.lumin-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.lumin-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  onSlideChange () {
    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay (video) {
    const card = video.closest('.lumin-shoppable-videos-card')

    this.querySelectorAll('.lumin-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }
}
customElements.define('lumin-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();
})();
